export default __webpack_public_path__ + "static/media/logo-small.b6e8110f.png";